import service from '@/utils/request'; // 获取分销商列表
// @Tags TicketManage
// @Summary 获取分销商列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取分销商列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/rule/getList [get]

export var getCapitalRelationList = function getCapitalRelationList(params) {
  return service({
    url: '/capital/relation/getList',
    method: 'get',
    params: params
  });
}; // 优惠券规则-分页获取列表
// @Tags TicketManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/rule/getList [get]

export var getTicketRuleList = function getTicketRuleList(params) {
  return service({
    url: '/ticket/rule/getList',
    method: 'get',
    params: params
  });
}; // 优惠券规则-查询单个详情
// @Tags TicketManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/rule/detail [post]

export var getTicketRuleDetail = function getTicketRuleDetail(data) {
  return service({
    url: '/ticket/rule/detail',
    method: 'post',
    data: data
  });
}; // 优惠券规则-新增
// @Tags TicketManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/rule/create [post]

export var createTicketRule = function createTicketRule(data) {
  return service({
    url: '/ticket/rule/create',
    method: 'post',
    data: data
  });
}; // 优惠券规则-变更
// @Tags TicketManage
// @Summary 变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/rule/update [post]

export var updateTicketRule = function updateTicketRule(data) {
  return service({
    url: '/ticket/rule/update',
    method: 'post',
    data: data
  });
}; // 优惠券规则-删除
// @Tags TicketManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /ticket/rule/delete [delete]

export var deleteTicketRule = function deleteTicketRule(data) {
  return service({
    url: '/ticket/rule/delete',
    method: 'post',
    data: data
  });
}; // 用户优惠券-分页获取列表
// @Tags TicketManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/user/getList [get]

export var getUserTicket = function getUserTicket(params) {
  return service({
    url: '/ticket/user/getList',
    method: 'get',
    params: params
  });
}; // 用户优惠券-删除
// @Tags TicketManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/user/update [post]

export var postTicketUserUpdate = function postTicketUserUpdate(data) {
  return service({
    url: '/ticket/user/update',
    method: 'post',
    data: data
  });
}; // 批量送券-分页获取列表
// @Tags TicketManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /ticket/batch/getList [get]

export var getBatchSendTicket = function getBatchSendTicket(params) {
  return service({
    url: '/ticket/batch/getList',
    method: 'get',
    params: params
  });
}; // 批量送券-导出异常数据
// @Tags TicketManage
// @Summary 导出异常数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "导出异常数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /ticket/batch/download/error [delete]

export var downloadBatchErrorTicket = function downloadBatchErrorTicket(data) {
  return service({
    url: '/ticket/batch/download/error',
    method: 'post',
    data: data
  });
}; // 批量送券-批量送券
// @Tags TicketManage
// @Summary 批量送券
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "批量送券"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /ticket/batch/give/tickets [post]

export var BatchGiveTicket = function BatchGiveTicket(data) {
  return service({
    url: '/ticket/batch/give/tickets/bymobile',
    method: 'post',
    data: data
  });
};
export var getOilTicketShareList = function getOilTicketShareList(params) {
  return service({
    url: '/ticket/user/share/getList',
    method: 'get',
    params: params
  });
};
export var downloadOilTicketShareList = function downloadOilTicketShareList(data) {
  return service({
    url: '/ticket/user/share/download',
    method: 'post',
    data: data
  });
};